import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addClient } from '../services/api';
import { showErrorToast, showLoadingToast, updateLoadingToastSuccess, updateLoadingToastError } from '../utils/toastConfig';
import { FiArrowLeft } from 'react-icons/fi';
import './AddClient.css';

const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
  'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
  'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
  'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Puducherry', 'Chandigarh',
  'Andaman and Nicobar Islands', 'Dadra and Nagar Haveli and Daman and Diu', 'Lakshadweep',
];

const AddClient = ({closeModal,refreshClients}) => {
  const [form, setForm] = useState({
    client_name: '',
    address: '',
    gst_number: '',
    state: '',
    sector: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!form.client_name || !form.gst_number || !form.address || !form.state || !form.sector) {
      showErrorToast('Please fill in all required fields');
      return;
    }
    
    setLoading(true);
    const toastId = showLoadingToast('Adding client...');
    
    try {
      await addClient(form);
      updateLoadingToastSuccess(toastId, 'Client added successfully! ✨');
      refreshClients(); 
      setTimeout(() => {
        closeModal();
      }, 1000);
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Failed to add client';
      setError(errorMsg);
      updateLoadingToastError(toastId, errorMsg);
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-card">
        <button className="btn-back" onClick={closeModal}>
          <FiArrowLeft /> Back to Dashboard
        </button>
        <h2>Add New Client</h2>
        <form onSubmit={handleSubmit}>
          {error && <div className="error-msg">{error}</div>}
       <div className="form-row">

  <div className="form-group">
    <label>Client Name *</label>
    <input
      type="text"
      name="client_name"
      value={form.client_name}
      onChange={handleChange}
      placeholder="Enter client name"
      required
    />
  </div>

  <div className="form-group">
    <label>GST Number *</label>
    <input
      type="text"
      name="gst_number"
      value={form.gst_number}
      onChange={handleChange}
      placeholder="e.g., 36AABCU9603R1ZM"
      maxLength={15}
      required
    />
  </div>

</div>
          <div className="form-group">
            <label>Address *</label>
            <textarea
              name="address"
              value={form.address}
              onChange={handleChange}
              placeholder="Enter full address"
              rows={3}
              required
            />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>State *</label>
              <select name="state" value={form.state} onChange={handleChange} required>
                <option value="">Select State</option>
                {INDIAN_STATES.map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Sector *</label>
              <select name="sector" value={form.sector} onChange={handleChange} required>
                <option value="">Select Sector</option>
                <option value="Education">Education</option>
                <option value="Information Technology">Information Technology</option>
              </select>
            </div>
          </div>
          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? 'Adding...' : 'Add Client'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddClient;
